import { render, staticRenderFns } from "./SearchTip.vue?vue&type=template&id=72117fbc&scoped=true&"
import script from "./SearchTip.vue?vue&type=script&lang=js&"
export * from "./SearchTip.vue?vue&type=script&lang=js&"
import style0 from "./SearchTip.vue?vue&type=style&index=0&id=72117fbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72117fbc",
  null
  
)

export default component.exports